var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wish-list",attrs:{"id":"wish-list"}},_vm._l((_vm.currentPosts),function(post,index){return _c('surface-post',{key:post.cid,attrs:{"index":index,"post":post,"edit":_vm.inlinePostEdit}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }